import React from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { Avatar } from '@material-ui/core';
import styles from "./MemberIdentifyingUnit.module.scss";
import typography from 'seagull/foundations/typography.module.scss';
import colors from 'seagull/foundations/colors.module.scss';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
  styledAvatar: {
    backgroundColor: colors.purple300,
    fontFamily: typography.fontFamilyNormal,
    fontSize: typography.fontSizeP1,
    lineHeight: typography.lineHeightP1
  }
}));
export function MemberIdentifyingUnit(_ref) {
  let {
    user,
    testId
  } = _ref;
  const userInitials = user.initials();
  const moreStyles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: cn(styles.avatar, moreStyles.styledAvatar)
  }, userInitials), /*#__PURE__*/React.createElement("div", {
    className: styles.details
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "".concat(testId, "-full-name")
  }, user.fullName()), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    "data-testid": "".concat(testId, "-email"),
    ellipsis: true
  }, user.email())));
}